import moment, { tz } from 'moment';
import 'moment-timezone';
export default {
    
    filters:{
    },
    methods:{
        getFormattedDateTime(param, format='MMMM Do YYYY, h:mm:ss a'){ 
 
             // Defalut Format December 15th 2021, 6:10:05 pm

             if(param){
                let formatted_time=moment.utc(param).tz('America/New_York').format(format);
                return formatted_time;
             }
             return 'Not Found';

        },
        getFormattedDate(param, format='DD MMM YYYY') { 
            // Default Format: 20 Feb 2024
            let formatted_time = moment.utc(param).tz('America/New_York').format(format);
            return formatted_time;
        },
        formatTime(time) {
            // Create a new Date object using today's date and the given time
            const date = new Date(`1970-01-01T${time}Z`);
            
            // Get hours and minutes
            let hours = date.getUTCHours();
            const minutes = date.getUTCMinutes();
            
            // Determine AM/PM
            const ampm = hours >= 12 ? 'PM' : 'AM';
            
            // Convert 24-hour time to 12-hour time
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            
            // Format minutes with leading zero if necessary
            const minutesStr = minutes < 10 ? '0' + minutes : minutes;
            
            return `${hours}:${minutesStr} ${ampm}`;
        },
        getDateCustomZone(param, format = 'DD MMM YYYY'){
                 // Default Format: 20 Feb 2024 Add a mixin for a resolve issue if time is 00:00:00
                let formatted_time = moment(param).format(format);
                return formatted_time;
         }
        
      
      
    }
}
    